const baseURL = process.env.REACT_APP_BASE_URL;// 'https://team.tomi.la/server/';

export async function getProfile (token) {
    const data = new FormData();
    data.append('token', token);
    let result = await loadJson (data, 'user_permission');
    return result;
}

/** Ruta de inicio: internos (usr_type 0) van a tareas; el resto al dashboard. */
export function getDefaultAppPath(usrType) {
    return parseInt(usrType, 10) === 0 ? '/tactic_followup' : '/Dashboard';
}

export async function get_all_team_users(token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson(data, 'admin/list_team_users');
}

export async function update_team_user_field(token, user_id, field, value) {
    const data = new FormData();
    data.append('token', token);
    data.append('user_id', user_id);
    data.append('field', field);
    data.append('value', value ?? '');
    return await loadJson(data, 'admin/update_team_user_field');
}

export async function get_all_products(token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson(data, 'admin/list_products');
}

export async function update_product_field(token, product_id, field, value) {
    const data = new FormData();
    data.append('token', token);
    data.append('product_id', product_id);
    data.append('field', field);
    data.append('value', value ?? '');
    return await loadJson(data, 'admin/update_product_field');
}

export async function add_product(token, product) {
    const data = new FormData();
    data.append('token', token);
    data.append('name', product.name ?? '');
    data.append('description', product.description ?? '');
    data.append('exw_price', product.exw_price ?? 0);
    data.append('cost', product.cost ?? 0);
    data.append('prod_status', product.prod_status ?? 1);
    return await loadJson(data, 'admin/add_product');
}

export async function dashboard_data (token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'dashboard_data');
}


export async function save_new_issue (token, theSerial, mode,  usr_id, estado, issue_type = 0) {
    const data = new FormData();
    data.append('token', token);
    data.append('serial', theSerial);
    data.append('mode', mode);
    data.append('usr_id', usr_id);
    data.append('estado', estado);
    data.append('issue_type', issue_type);
    return await loadJson (data, 'helpdesk/save_new_issue2');
}

export async function add_user_permission_to_issue (token, issue_id, usr_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('issue_id', issue_id);
    data.append('usr_id', usr_id);
    let result = await loadJson (data, 'helpdesk/add_user_permission_to_issue');
    return result;
}

export async function load_issue_observers (token, issue_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('issue_id', issue_id);
    let result = await loadJson (data, 'helpdesk/load_issue_observers');
    return result;
}


export async function save_annotation (token, issue_id, newAnnotationText,usr_id, file, type) {
    const data = new FormData();
    data.append('token', token);
    data.append('issue_id', issue_id);
    data.append('newAnnotationText', newAnnotationText);
    data.append('usr_id', usr_id);
    data.append('type', type);
    data.append('file', file);
    return await loadJson (data, 'helpdesk/save_annotation2');
}

export async function load_annotations (token, issue_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('issue_id', issue_id);
    return await loadJson (data, 'helpdesk/load_annotations');
}




export async function get_usr_by_email (token, email) {
    const data = new FormData();
    data.append('token', token);
    data.append('email', email);
    let result = await loadJson (data, 'get_usr_by_email');
    return result;
}



export async function invite_user (token, email) {
    const data = new FormData();
    data.append('token', token);
    data.append('email', email);
    let result = await loadJson (data, 'invite_user');
    return result;
}


export async function check_set_pwd (token, email) {
    const data = new FormData();
    data.append('token', token);
    data.append('email', email);
    let result = await loadJson (data, 'check_set_pwd');
    return result;
}


export async function set_pwd (token, email, pwd, usr_name) {
    const data = new FormData();
    data.append('token', token);
    data.append('email', email);
    data.append('pwd', pwd);
    data.append('usr_name', usr_name);
    let result = await loadJson (data, 'set_pwd');
    return result;
}

export async function update_issue (token, issue_id, persona_contacto, email_contacto, telefono_contacto, canal, direccion_contacto) {
    const data = new FormData();
    data.append('token', token);
    data.append('issue_id', issue_id);
    data.append('persona_contacto', persona_contacto);
    data.append('email_contacto', email_contacto);
    data.append('canal', canal);
    data.append('telefono_contacto', telefono_contacto);
    data.append('direccion_contacto', direccion_contacto);

    return await loadJson (data, 'helpdesk/update_issue2');
}


export async function add_typo_to_issue (token, issue_id, typo_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('issue_id', issue_id);
    data.append('typo_id', typo_id);
    return await loadJson (data, 'helpdesk/add_typo_to_issue');
}

export async function add_bug_to_issue (token, issue_id, bug_id, title, urlTrello) {
    const data = new FormData();
    data.append('token', token);
    data.append('issue_id', issue_id);
    data.append('bug_id', bug_id);
    data.append('title', title);
    data.append('urlTrello', urlTrello);
    return await loadJson (data, 'helpdesk/add_bug_to_issue');
}







export async function remove_issue_typos (token, link_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('link_id', link_id);
    return await loadJson (data, 'helpdesk/remove_issue_typos');
}

export async function remove_issue_bug (token, link_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('link_id', link_id);
    return await loadJson (data, 'helpdesk/remove_issue_bug');
}


export async function remove_issue_observer (token, link_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('link_id', link_id);
    return await loadJson (data, 'helpdesk/remove_issue_observer');
}

export async function add_serial_observer (token, serial_num, email_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('serial_num', serial_num);
    data.append('email_id', email_id);
    return await loadJson(data, 'helpdesk/add_serial_observer');
}

export async function load_serial_observers (token, serial_num) {
    const data = new FormData();
    data.append('token', token);
    data.append('serial_num', serial_num);
    return await loadJson(data, 'helpdesk/load_serial_observers');
}

export async function remove_serial_observer (token, link_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('link_id', link_id);
    return await loadJson(data, 'helpdesk/remove_serial_observer');
}

export async function load_issue_typos (token, issue_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('issue_id', issue_id);
    return await loadJson (data, 'helpdesk/load_issue_typos');
}

export async function load_issue_bugs (token, issue_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('issue_id', issue_id);
    return await loadJson (data, 'helpdesk/load_issue_bugs');
}


export async function set_CAS_to_issue (token, issue_id, channel_id, start_cas_flow = 1) {
    const data = new FormData();
    data.append('token', token);
    data.append('issue_id', issue_id);
    data.append('channel_id', channel_id);
    data.append('start_cas_flow', start_cas_flow ? 1 : 0);
    return await loadJson (data, 'helpdesk/set_CAS_to_issue');
}




export async function save_new_model_issue (token, model_ref, newAnnotationText, newType, usr_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('model_ref', model_ref);
    data.append('newAnnotationText', newAnnotationText);
    data.append('newType', newType);
    data.append('usr_id', usr_id);
    return await loadJson (data, 'save_new_model_issue');
}

export async function close_session (token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'close_session');
}


export async function change_ticket_status (token, issue_id, newStatus, typeStatus) {
    const data = new FormData();
    data.append('token', token);
    data.append('issue_id', issue_id);
    data.append('newStatus', newStatus);
    data.append('typeStatus', typeStatus);
    return await loadJson (data, 'helpdesk/change_ticket_status');
}

export async function update_status (token, theSerial, status_type, fecha_warranty, gift_device) {
    const data = new FormData();
    data.append('token', token);
    data.append('serial', theSerial);
    data.append('status_type', status_type);
    data.append('fecha_warranty', fecha_warranty);
     data.append('gift_device', gift_device);
    return await loadJson (data, 'update_status');
}


export async function add_serial (token, theSerial, sub_cat, project_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('serial', theSerial);
    data.append('project_id', project_id);
    data.append('sub_cat', sub_cat);
    return await loadJson (data, 'add_serial');
}

// Edita el sub_cat de un serial del proyecto (projects_relations.sub_cat). Devuelve "OK"/"INVALID".
export async function update_serial_sub_cat (token, id_relation, project_id, sub_cat) {
    const data = new FormData();
    data.append('token', token);
    data.append('id_relation', id_relation);
    data.append('project_id', project_id);
    data.append('sub_cat', sub_cat);
    return await loadJson (data, 'update_serial_sub_cat');
}

/**
 * Inserta pines en project_pins (lista separada por comas; conviene enviar lotes razonables).
 * Respuesta JSON: { status, inserted, skipped_duplicates, received } o "INVALID".
 */
export async function insert_project_pins(token, project_id, pinsCommaSeparated) {
    const data = new FormData();
    data.append('token', token);
    data.append('project_id', String(project_id));
    data.append('pins', pinsCommaSeparated);
    return await loadJson(data, 'insert_project_pins');
}

const PROJECT_PINS_CHUNK = 2500;

/** Envía muchos pines en varias solicitudes (cada una con lista separada por comas). */
export async function insert_project_pins_batches(token, project_id, pinsArray) {
    const list = Array.isArray(pinsArray) ? pinsArray.filter((p) => String(p).trim()) : [];
    if (list.length === 0) {
        return { status: 'OK', inserted: 0, skipped_duplicates: 0 };
    }
    let inserted = 0;
    let skipped = 0;
    for (let i = 0; i < list.length; i += PROJECT_PINS_CHUNK) {
        const chunk = list.slice(i, i + PROJECT_PINS_CHUNK);
        const res = await insert_project_pins(token, project_id, chunk.join(','));
        if (res == null) {
            return null;
        }
        if (res === 'INVALID') {
            return 'INVALID';
        }
        if (res && res.status === 'INVALID') {
            return res;
        }
        if (typeof res === 'object' && res !== null && res.status === 'OK') {
            inserted += res.inserted ?? 0;
            skipped += res.skipped_duplicates ?? 0;
        }
    }
    return { status: 'OK', inserted, skipped_duplicates: skipped };
}



export async function delete_projects_relation (token, id_to_delete) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id_to_delete);
    return await loadJson (data, 'delete_projects_relation');
}

/** link_external: 1 = lista Brevo, 0 = lista interna de pines */
export async function update_project_link_external(token, projectId, linkExternal) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', String(projectId));
    data.append('link_external', String(linkExternal));
    return await loadJson(data, 'update_project_link_external');
}

export async function update_project(token, id, nombre_proy, link_token, link_id, link_name, country, licensed_until = null) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    data.append('nombre_proy', nombre_proy);
    data.append('link_token', link_token);
    data.append('link_id', link_id);
    data.append('link_name', link_name);
    data.append('country', country);
    if (licensed_until != null && licensed_until !== '') {
        data.append('licensed_until', String(licensed_until));
    } else {
        // Keep backend update deterministic (clear value)
        data.append('licensed_until', '');
    }
    return await loadJson (data, 'update_project');
}

export async function archive_project(token, id) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    return await loadJson(data, 'archive_project');
}


export async function get_models (token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'get_models');
}

export async function  start_sesion (token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'start_sesion2');
}

export async function  start_sesion_email (email, password) {
    const data = new FormData();
    data.append('email', email);
    data.append('password', password);
    return await loadJson (data, 'start_sesion_email2');
}


export async function getPackages (token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'get_packages');
}


export async function get_package_versions (token, package_name, current_version) {
    const data = new FormData();
    data.append('token', token);
    data.append('package_name', package_name);
    data.append('current_version', current_version);

    return await loadJson (data, 'get_package_versions');
}


export async function deploy_update (token, selectedProject, selectedCapacity, selectedModel, version2deploy, selectedPackagename) {
    const data = new FormData();
    data.append('token', token);
    data.append('selectedProject', selectedProject);
    data.append('selectedCapacity', selectedCapacity);
    data.append('selectedModel', selectedModel);
    data.append('version2deploy', version2deploy);
    data.append('selectedPackagename', selectedPackagename);

    return await loadJson (data, 'deploy_update');
}

export async function upload_transaction_CSV (token, fileCSV, usr_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('fileCSV', fileCSV);
    data.append('usr_id', usr_id);

    return await loadJson (data, 'financial/upload_transaction_CSV');
}



export async function create_new_version (token, package_name, file, comments, versionCode, versionName,  fileEN,fileES,fileAR,filePT, fileBannerVid) {
    const data = new FormData();
    data.append('token', token);
    data.append('package_name', package_name);
    data.append('file', file);
    data.append('comments', comments);
    data.append('versionCode', versionCode);
    data.append('versionName', versionName);
    data.append('fileEN', fileEN);
    data.append('fileES', fileES);
    data.append('filePT', filePT);
    data.append('fileAR', fileAR);
    data.append('fileBannerVid', fileBannerVid);


    return await loadJson (data, 'create_new_version');
}

export async function get_subsystem_versions(token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson(data, 'debian_subsystem/list_subsystem_versions');
}

export async function create_subsystem_version(
    token,
    package_name,
    description,
    type,
    file,
    onProgress,
    shortcut_label = '',
    shortcut_icon = null,
    shortcut_local_url = '',
    reserved_port = '',
    license_app_id = ''
) {
    const data = new FormData();
    data.append('token', token);
    data.append('package_name', package_name);
    data.append('description', description);
    data.append('type', type);
    data.append('shortcut_label', shortcut_label ?? '');
    data.append('shortcut_local_url', shortcut_local_url ?? '');
    data.append('reserved_port', reserved_port ?? '');
    data.append('license_app_id', license_app_id ?? '');
    data.append('file', file);
    if (shortcut_icon) {
        data.append('shortcut_icon', shortcut_icon);
    }
    return await loadJsonWithUploadProgress(data, 'debian_subsystem/create_subsystem_version', onProgress);
}

export async function update_subsystem_version(
    token,
    id,
    package_name,
    description,
    type,
    file,
    onProgress,
    shortcut_label = '',
    shortcut_icon = null,
    shortcut_local_url = '',
    reserved_port = '',
    license_app_id = ''
) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    data.append('package_name', package_name);
    data.append('description', description);
    data.append('type', type);
    data.append('shortcut_label', shortcut_label ?? '');
    data.append('shortcut_local_url', shortcut_local_url ?? '');
    data.append('reserved_port', reserved_port ?? '');
    data.append('license_app_id', license_app_id ?? '');
    if (shortcut_icon) {
        data.append('shortcut_icon', shortcut_icon);
    }
    if (file || shortcut_icon) {
        if (file) {
            data.append('file', file);
        }
        return await loadJsonWithUploadProgress(data, 'debian_subsystem/update_subsystem_version', onProgress);
    }
    return await loadJson(data, 'debian_subsystem/update_subsystem_version');
}

export async function delete_subsystem_version(token, id) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    return await loadJson(data, 'debian_subsystem/delete_subsystem_version');
}

export async function loadIssueType(token){
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'get_issue_types');
}



  // Crear un formateador de moneda para dólares estadounidenses
export const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2, // Opcional: asegura al menos dos decimales
    maximumFractionDigits: 2, // Opcional: asegura como máximo dos decimales
  });

export const numberFormatter = new Intl.NumberFormat('en-US');

export async function loadIssueType_helpdesk(token){
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'helpdesk/get_issue_types');
}

export async function load_CAS_names(token){
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'helpdesk/load_CAS_names');
}

export async function load_Bugs_list(token){
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'helpdesk/get_bugs');
}


export async function get_issue_full(token, issue_id){
    const data = new FormData();
    data.append('token', token);
    data.append('issue_id', issue_id);
    return await loadJson (data, 'helpdesk/get_issue_full');
}

export async function get_open_issues(token){
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'helpdesk/get_open_issues2');
}

export async function get_closed_issues(token){
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'helpdesk/get_closed_issues');
}

export async function get_typology_stats(token, filters = {}){
    const data = new FormData();
    data.append('token', token);
    if (filters.cas_only) data.append('cas_only', '1');
    if (filters.date_start) data.append('date_start', filters.date_start);
    if (filters.date_end) data.append('date_end', filters.date_end);
    return await loadJson (data, 'helpdesk/get_typology_stats');
}

export async function get_typology_cases(token, filters = {}){
    const data = new FormData();
    data.append('token', token);
    data.append('type_id', filters.type_id ?? '');
    if (filters.cas_only) data.append('cas_only', '1');
    if (filters.date_start) data.append('date_start', filters.date_start);
    if (filters.date_end) data.append('date_end', filters.date_end);
    return await loadJson (data, 'helpdesk/get_typology_cases');
}

export async function add_project(token, payload) {
    const data = new FormData();
    data.append('token', token);

    // Backwards compatible: allow string project name, or object payload
    if (typeof payload === 'string') {
        data.append('projectName', payload);
        return await loadJson(data, 'add_project');
    }

    const projectName = payload?.projectName ?? payload?.name ?? '';
    data.append('projectName', projectName);

    const externalLicenseUntil =
        payload?.external_license_until ??
        payload?.externalLicenseUntil ??
        payload?.external_license_until_date ??
        '';

    if (externalLicenseUntil != null && String(externalLicenseUntil) !== '') {
        data.append('external_license_until', String(externalLicenseUntil));
    }

    return await loadJson(data, 'add_project');
}



export async function get_projects(token){
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'get_projects');
}

// Base del lab-dashboard-backend. Derivada del host (sin env, para no sumar un archivo
// más al deploy manual): en local apunta al backend local; en cualquier otro host, a prod.
function labApiBase() {
    const h = window.location.hostname;
    return (h === 'localhost' || h === '127.0.0.1')
        ? 'http://localhost:8081'
        : 'https://lab.tomi.la/api/dashboards';
}

// North Star de empresa (indicador de la barra superior). Solo internos @tomi.digital
// (403 si no). Devuelve {month, meta1:{current,previous,delta,series}, meta2:{...}} o null
// ante cualquier fallo (el indicador simplemente no se pinta). Cacheado 24h en el backend.
export async function get_north_star(token) {
    try {
        const res = await fetch(labApiBase() + '/projects/north-star', {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return null;
        const json = await res.json();
        return json?.data ?? null;
    } catch (err) {
        console.warn('[north-star] no se pudo obtener el north star', err);
        return null;
    }
}

// Índice de rendimiento por proyecto (columna ÍNDICE del comparador). FALLBACK: solo se
// usa cuando get_projects (PHP) todavía NO inyecta el índice. Cross-project, solo internos
// @tomi.digital (403 si no). Devuelve el array o null ante cualquier fallo (degradación
// silenciosa: la columna muestra "—"). Ver lab-backend GET /projects/performance-index.
export async function get_projects_performance_index(token) {
    try {
        const res = await fetch(labApiBase() + '/projects/performance-index', {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return null;
        const json = await res.json();
        return json?.data ?? null;
    } catch (err) {
        console.warn('[índice] no se pudo obtener el índice de rendimiento', err);
        return null;
    }
}

export async function get_unique_countries(token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson(data, 'devices_admin/get_unique_countries');
}

export async function list_campaigns(token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson(data, 'devices_admin/list_campaigns');
}

export async function get_campaign(token, id) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', String(id));
    const res = await fetch(process.env.REACT_APP_BASE_URL + 'devices_admin/get_campaign.php', {
        method: 'POST',
        body: data,
    });
    const text = await res.text();
    if (text === '' || text === 'INVALID') return 'INVALID';
    try {
        const parsed = JSON.parse(text);
        return parsed.error ? parsed : parsed;
    } catch {
        return { error: text };
    }
}

export async function save_campaign(token, payload) {
    const data = new FormData();
    data.append('token', token);
    Object.keys(payload).forEach((k) => {
        const v = payload[k];
        if (k === 'id' && (v === 0 || v === '' || v == null)) return;
        if (v != null && v !== '') data.append(k, typeof v === 'object' ? JSON.stringify(v) : String(v));
    });
    const res = await fetch(process.env.REACT_APP_BASE_URL + 'devices_admin/save_campaign.php', { method: 'POST', body: data });
    const text = await res.text();
    if (text === '' || text === 'INVALID') return { ok: false, error: 'INVALID' };
    try {
        return JSON.parse(text);
    } catch {
        return { ok: false, error: text };
    }
}

export async function delete_campaign(token, id) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    const res = await fetch(process.env.REACT_APP_BASE_URL + 'devices_admin/delete_campaign.php', { method: 'POST', body: data });
    const text = await res.text();
    if (text === '' || text === 'INVALID') return { ok: false };
    try {
        return JSON.parse(text);
    } catch {
        return { ok: false };
    }
}

/**
 * Envía o programa una campaña: inserta en push_notification_tomi8 y marca campaña como enviada.
 * @param {string} token
 * @param {number} campaign_id
 * @param {string|null} delivery_date - Opcional. Si no se envía o es null, el backend usa NOW().
 * @returns {Promise<{ok: boolean, error?: string, inserted?: number, total_serials?: number}>}
 */
export async function dispatch_campaign(token, campaign_id, delivery_date = null) {
    const data = new FormData();
    data.append('token', token);
    data.append('campaign_id', String(campaign_id));
    if (delivery_date != null && delivery_date !== '') {
        data.append('delivery_date', String(delivery_date));
    }
    const res = await fetch(process.env.REACT_APP_BASE_URL + 'devices_admin/dispatch_campaign.php', { method: 'POST', body: data });
    const text = await res.text();
    if (text === '' || text === 'INVALID') return { ok: false, error: 'INVALID' };
    try {
        return JSON.parse(text);
    } catch {
        return { ok: false, error: text };
    }
}

export async function get_campaign_stats(token, campaign_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('campaign_id', String(campaign_id));
    const res = await fetch(process.env.REACT_APP_BASE_URL + 'devices_admin/get_campaign_stats.php', { method: 'POST', body: data });
    const text = await res.text();
    if (text === '' || text === 'INVALID') return { ok: false, error: 'INVALID' };
    try {
        return JSON.parse(text);
    } catch {
        return { ok: false, error: text };
    }
}

export async function cancel_campaign(token, campaign_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('campaign_id', String(campaign_id));
    const res = await fetch(process.env.REACT_APP_BASE_URL + 'devices_admin/cancel_campaign.php', { method: 'POST', body: data });
    const text = await res.text();
    if (text === '' || text === 'INVALID') return { ok: false, error: 'INVALID' };
    try {
        return JSON.parse(text);
    } catch {
        return { ok: false, error: text };
    }
}

export async function get_count_recipients(token, { recipient_type, project_id, country, model, serials }) {
    const data = new FormData();
    data.append('token', token);
    data.append('recipient_type', recipient_type);
    if (project_id != null && project_id !== '') data.append('project_id', project_id);
    if (country != null && country !== '') data.append('country', country);
    if (model != null && model !== '') data.append('model', model);
    if (Array.isArray(serials)) data.append('serials', JSON.stringify(serials));
    const response = await fetch(process.env.REACT_APP_BASE_URL + 'devices_admin/count_recipients.php', {
        method: 'POST',
        body: data,
    });
    const text = await response.text();
    if (text === '' || text.startsWith('INVALID')) return { error: 'INVALID', total_serials: 0, total_with_version_gt_214: 0 };
    try {
        return JSON.parse(text);
    } catch {
        return { error: text, total_serials: 0, total_with_version_gt_214: 0 };
    }
}

export async function request_brevo_csv (token, listid, link_token) {
    const data = new FormData();
    data.append('token', token);
    data.append('listid', listid);
    data.append('link_token', link_token);
    return await loadJson (data, 'brevo/request_brevo_csv');
}

/**
 * Actualiza BigQuery (mismo pipeline que el CSV de Brevo) desde project_pins.
 * POST a list_update_bigq.php con from_project_pins=1; requiere link_external=0.
 */
export async function sync_project_pins_to_bigquery(token, projectId) {
    const data = new FormData();
    data.append('token', token);
    data.append('project_id', String(projectId));
    data.append('from_project_pins', '1');
    return await loadJson(data, 'brevo/list_update_bigq');
}

/**
 * Re-aplica ciudad/institución del master de IEs (tomi8_db.ies*) sobre el roster
 * BigQuery del proyecto. Se llama tras sync_project_pins_to_bigquery, porque ese
 * sync reescribe el slice SIN atributos y tumba los filtros Ciudad/Institución del
 * dashboard. Best-effort: si falla, la scheduled query del lab lo repara en <=4h.
 */
export async function refresh_ies_enrichment(token, projectId) {
    try {
        const res = await fetch(`${labApiBase()}/project/${projectId}/ies-enrichment/refresh`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return null;
        return (await res.json())?.data ?? null;
    } catch (err) {
        console.warn('[ies-enrichment] no se pudo re-aplicar el enriquecimiento', err);
        return null;
    }
}

/**
 * Manda rehacer las fotos de BigQuery que dependen del roster.
 *
 * El dashboard no lee datos en vivo: lee tablas fotografiadas una vez al día por la
 * mañana. Sin este paso, cambiar el roster no se ve hasta el día siguiente — que fue
 * exactamente lo que pasó con la Cohorte 2: se enrolaron sus 28 maestros dos horas
 * después de la foto y la página siguió diciendo "Sin clases este mes" para todos.
 *
 * Devuelve al instante (202): la pasada tarda ~1 minuto y se sigue por `status`. Va
 * con force=1 porque aquí SABEMOS que el roster acaba de cambiar; el freno del backend
 * está para los dobles clics, no para esto.
 */
export async function refresh_dashboard_snapshots(token, projectId) {
    try {
        const res = await fetch(`${labApiBase()}/project/${projectId}/snapshots/refresh?force=1`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return null;
        return (await res.json())?.data ?? null;
    } catch (err) {
        console.warn('[snapshots] no se pudo arrancar la rematerialización', err);
        return null;
    }
}

/** Cómo va la rematerialización: { running, error, result, previousMaterializedAt }. */
export async function get_snapshots_status(token, projectId) {
    try {
        const res = await fetch(`${labApiBase()}/project/${projectId}/snapshots/status`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return null;
        return (await res.json())?.data ?? null;
    } catch (err) {
        console.warn('[snapshots] no se pudo consultar el estado', err);
        return null;
    }
}

// ---------------------------------------------------------------------------
// Miembros del proyecto (lab-dashboard-backend). Un usuario pertenece a un proyecto
// por una o VARIAS puertas: pin redimido, TOMi vinculado, lista (users_by_project) o
// relación directa ("manual"). Solo la última está almacenada, y por eso es la única
// que se puede quitar desde aquí — las otras son reflejos de otra tabla y volverían
// en el siguiente request.
//
// Esta lista NO se puede armar en PHP: tres puertas están en tomi8_db pero la lista
// vive en BigQuery, y solo el lab la alcanza. Solo internos (403 si no).
// ---------------------------------------------------------------------------

/** Devuelve { members: [...], summary: {...} } o null ante cualquier fallo. */
export async function get_project_members(token, projectId) {
    try {
        const res = await fetch(`${labApiBase()}/project/${projectId}/members`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return null;
        return (await res.json())?.data ?? null;
    } catch (err) {
        console.warn('[members] no se pudo obtener la lista de miembros', err);
        return null;
    }
}

/**
 * Agrega a alguien por la puerta manual. `iesId` es opcional: se puede pertenecer sin
 * institución conocida (el caso típico es el maestro al que le dieron un pin y no lo
 * redimió porque ya tenía licencia). Devuelve { ok, result } o { ok:false, message }.
 */
export async function add_project_member(token, projectId, userId, iesId) {
    try {
        const res = await fetch(`${labApiBase()}/project/${projectId}/members`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify({ userId, iesId: iesId ?? null }),
        });
        const json = await res.json().catch(() => null);
        if (!res.ok) return { ok: false, message: json?.message || 'No se pudo agregar.' };
        return { ok: true, result: json?.data?.result ?? 'created' };
    } catch (err) {
        console.warn('[members] no se pudo agregar el miembro', err);
        return { ok: false, message: 'Sin conexión con el dashboard.' };
    }
}

/** Quita a un miembro manual. 409 si entra por otra puerta (mensaje del servidor). */
export async function remove_project_member(token, projectId, userId) {
    try {
        const res = await fetch(`${labApiBase()}/project/${projectId}/members/${userId}`, {
            method: 'DELETE',
            headers: { Authorization: `Bearer ${token}` },
        });
        const json = await res.json().catch(() => null);
        if (!res.ok) return { ok: false, message: json?.message || 'No se pudo quitar.' };
        return { ok: true };
    } catch (err) {
        console.warn('[members] no se pudo quitar el miembro', err);
        return { ok: false, message: 'Sin conexión con el dashboard.' };
    }
}

export async function validate_procces (proc_id) {
    const data = new FormData();
    data.append('proc_id', proc_id);
    return await loadJson (data, 'brevo/validate_procces');
}
export async function get_project_permissions (token, project_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('project_id', project_id);
    return await loadJson (data, 'get_project_permissions');
}

export async function get_brevo_lists(token, folderid){
    const data = new FormData();
    data.append('token', token);
    data.append('folderid', folderid);
    return await loadJson (data, 'brevo/get_brevo_lists');
}

export async function get_brevo_folders(token){
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'brevo/get_brevo_folders');
}

export async function get_project_serials(token, id){
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    return await loadJson (data, 'get_project_serials');
}

/** Resuelve un email -> usuario TOMi vía musers: { users: [{ user_id, user_email, user_name }] }. */
export async function resolve_user_by_email(token, id, email){
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    data.append('email', email);
    return await loadJson(data, 'devices_admin/resolve_user_by_email');
}

/** Vincula un TOMi8 a un usuario: { ok, action } o { ok:false, error:{ code } } (incl. COOLDOWN_ACTIVE). */
export async function link_device_user(token, id, serial, usr_id_tomi){
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    data.append('serial', serial);
    data.append('usr_id_tomi', usr_id_tomi);
    return await loadJson(data, 'devices_admin/link_device_user');
}

/** Lista de pines del proyecto: { pins: [{ id, pin }, ...] } o INVALID */
export async function get_project_pins(token, projectId) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', String(projectId));
    return await loadJson(data, 'get_project_pins');
}

/** Sincroniza estados vía mpins batch + actualiza project_pins. { status, pins } o { status, message } o INVALID */
export async function sync_project_pins_batch(token, projectId) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', String(projectId));
    return await loadJson(data, 'pins_api/ProjectPinsBatchSync');
}

/** Elimina filas de project_pins por id. pin_ids: array de números o string "1,2,3". Respuesta { status, deleted, requested } o INVALID */
export async function delete_project_pins(token, projectId, pinIds) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', String(projectId));
    const idsStr = Array.isArray(pinIds) ? pinIds.join(',') : String(pinIds);
    data.append('pin_ids', idsStr);
    return await loadJson(data, 'delete_project_pins');
}

export async function get_project_opportunities(token, projectId) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', projectId);
    return await loadJson(data, 'get_project_opportunities');
}

export async function delete_projects_permission(token, id_permission){
    const data = new FormData();
    data.append('token', token);
    data.append('id_permission', id_permission);
    return await loadJson (data, 'delete_projects_permission');
}

export async function insert_projects_permission(token, email_id, project_id, usr_name = ''){
    const data = new FormData();
    data.append('token', token);
    data.append('email_id', email_id);
    data.append('project_id', project_id);
    if (usr_name) {
        data.append('usr_name', usr_name);
    }
    return await loadJson (data, 'insert_projects_permission');
}

/** Solo internos: permission 0 = miembro, 1 = administrador externo del proyecto. */
export async function update_projects_permission(token, id_permission, permission) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id_permission);
    data.append('permission', String(permission));
    return await loadJson(data, 'update_projects_permission');
}

export async function get_project_updt_status(token, projectId){
    const data = new FormData();
    data.append('token', token);
    data.append('project_id', String(projectId));
    return await loadJson (data, 'brevo/get_project_updt_status');
}

/** Solo con link_external = 0 (pines internos). */
export async function get_project_pins_dashboard_status(token, projectId) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', String(projectId));
    return await loadJson (data, 'pins_api/ProjectPinsDashboardStatus');
}

export async function loadStatusType(token){
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'get_status_types');
}

export async function getPackageVersion (token, packageName) {
    const data = new FormData();
    data.append('token', token);
    data.append('packageName', packageName);
    return await loadJson (data, 'get_versions_by_package');
}


export async function get_model_issues(token, reference){
    const data = new FormData();
    data.append('token', token);
    data.append('model_ref', reference);
    return await loadJson (data, 'get_model_issues');
}

export async function add_model(token, new_model){
    const data = new FormData();
    data.append('token', token);
    data.append('new_model', new_model);
    return await loadJson (data, 'add_model');
}


export async function authorize_vnc_channel (token, serialnum) {
    const data = new FormData();
    data.append('token', token);
    data.append('serialnum', serialnum);
    let result = await loadJson (data, 'helpdesk/authorize_vnc_channel');
    if (result === "INVALID" || result == null) {
        return result;
    }
    // Compatibilidad legacy: si backend antiguo responde array, normalizamos.
    if (Array.isArray(result)) {
        return {
            ok: result.length > 0,
            code: result.length > 0 ? 'AUTHORIZED' : 'NO_SLOT_AVAILABLE',
            message: result.length > 0 ? 'VNC channel authorized successfully.' : 'No available VNC slot found.',
            data: { slot: result[0] ?? null }
        };
    }
    return result;
}

export async function vnc_check_for_authorized_slot (token, serialnum) {
    const data = new FormData();
    data.append('token', token);
    data.append('serialnum', serialnum);
    let result = await loadJson (data, 'helpdesk/vnc_check_for_authorized_slot');
    if (result === "INVALID" || result == null) {
        return result;
    }
    if (Array.isArray(result)) {
        return {
            ok: result.length > 0,
            code: result.length > 0 ? 'SLOT_FOUND' : 'SLOT_NOT_FOUND',
            message: result.length > 0 ? 'Authorized slot found.' : 'No authorized slot found for this serial.',
            data: { slot: result[0] ?? null }
        };
    }
    return result;
}

export async function release_vnc_channel (token, serialnum) {
    const data = new FormData();
    data.append('token', token);
    data.append('serialnum', serialnum);
    return await loadJson(data, 'helpdesk/release_vnc_channel');
}


export async function update_destination (token, packageId, newDestination) {
    const data = new FormData();
    data.append('token', token);
    data.append('packageId', packageId);
    data.append('newDestination', newDestination);
    let result = await loadJson (data, 'update_destination');
    return result[0];
}

export async function get_devices_info(token, serial){
    const data = new FormData();
    data.append('token', token);
    data.append('serial', serial);
    return await loadJson (data, 'helpdesk/get_devices_info');
}

export async function load_issues(token, serial, mode){

    const data = new FormData();
    data.append('token', token);
    data.append('serial', serial);
    data.append('mode', mode);
    return await loadJson (data, 'helpdesk/load_issues');
}

export async function load_usage_timeline(token, serial){
    const data = new FormData();
    data.append('token', token);
    data.append('serial', serial);
    return await loadJson (data, 'helpdesk/get_usage_timeline');
}




export async function get_usr_info_by_email(token, email){

    const data = new FormData();
    data.append('token', token);
    data.append('email', email);
    return await loadJson (data, 'helpdesk/get_usr_info_by_email2');
}

/////////////// SERVICIOS PREMIUM /////


export async function get_contractor(token){
    const data = new FormData();
    data.append('token', token);
    return await loadJson (data, 'tomi_services/get_contractor');
}

export async function get_contractor_location(token, contractorToken){
    const data = new FormData();
    data.append('token', token);
    data.append('contractorToken', contractorToken);
    return await loadJson (data, 'tomi_services/get_contractor_location');
}

export async function get_location_devices(token, locationId){
    const data = new FormData();
    data.append('token', token);
    data.append('locationId', locationId);
    return await loadJson (data, 'tomi_services/get_location_devices');
}



export async function add_contractor(token, contractorName){
    const data = new FormData();
    data.append('token', token);
    data.append('contractorName', contractorName);
    return await loadJson (data, 'tomi_services/add_contractor');
}


export async function load_transactions(token, selectedUsr,dateRange){
    const data = new FormData();
    data.append('token', token);
    data.append('usr_id', selectedUsr);
    data.append('startDate', dateRange[0].toISOString().split('T')[0]); // YYYY-MM-DD
    data.append('endDate', dateRange[1].toISOString().split('T')[0]);
    return await loadJson (data, 'financial/load_transactions');
}

export async function get_account_list(token, type){
    const data = new FormData();
    data.append('token', token);
    data.append('type', type);
    return await loadJson (data, 'financial/get_account_list');
}

// Licencias STEM
export async function get_steam_licenses(serialNum) {
    return await loadJsonGET('t8_services/content_exclusive_check', { serial_num: serialNum });
}

export async function get_contents_exclusive() {
    return await loadJsonGET('t8_services/get_contents_exclusive');
}

export async function list_exclusive_contents(token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson(data, 'exclusive_content/list_contents');
}

export async function create_exclusive_content(token, name) {
    const data = new FormData();
    data.append('token', token);
    data.append('name', name);
    return await loadJson(data, 'exclusive_content/create_content');
}

export async function update_exclusive_content(token, id, name) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    data.append('name', name);
    return await loadJson(data, 'exclusive_content/update_content');
}

export async function delete_exclusive_content(token, id) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    return await loadJson(data, 'exclusive_content/delete_content');
}

export async function list_subscription_plans(token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson(data, 'exclusive_content/list_plans');
}

export async function create_subscription_plan(token, { name, description, price_monthly, price_annual, content_ids }) {
    const data = new FormData();
    data.append('token', token);
    data.append('name', name);
    data.append('description', description ?? '');
    data.append('price_monthly', price_monthly);
    data.append('price_annual', price_annual);
    data.append('content_ids', JSON.stringify(content_ids || []));
    return await loadJson(data, 'exclusive_content/create_plan');
}

export async function update_subscription_plan(token, { id, name, description, price_monthly, price_annual }) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    data.append('name', name);
    data.append('description', description ?? '');
    data.append('price_monthly', price_monthly);
    data.append('price_annual', price_annual);
    return await loadJson(data, 'exclusive_content/update_plan');
}

export async function delete_subscription_plan(token, id) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    return await loadJson(data, 'exclusive_content/delete_plan');
}

export async function link_plan_content(token, planId, contentId) {
    const data = new FormData();
    data.append('token', token);
    data.append('plan_id', planId);
    data.append('content_id', contentId);
    return await loadJson(data, 'exclusive_content/link_content');
}

export async function unlink_plan_content(token, planId, contentId) {
    const data = new FormData();
    data.append('token', token);
    data.append('plan_id', planId);
    data.append('content_id', contentId);
    return await loadJson(data, 'exclusive_content/unlink_content');
}

// Suscripciones de T8
export async function t8_subscribers_summary(token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson(data, 't8_subscribers/summary');
}

export async function t8_subscribers_get_by_serial(token, serial) {
    const data = new FormData();
    data.append('token', token);
    data.append('serial', serial);
    return await loadJson(data, 't8_subscribers/get_by_serial');
}

/** Busca suscriptor T8 por correo vinculado (tomi_email). */
export async function t8_subscribers_get_by_tomi_email(token, email) {
    const data = new FormData();
    data.append('token', token);
    data.append('email', email);
    return await loadJson(data, 't8_subscribers/get_by_tomi_email');
}

export async function t8_subscribers_list_plans(token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson(data, 't8_subscribers/list_plans');
}

export async function t8_subscribers_create(token, payload) {
    const data = new FormData();
    data.append('token', token);
    data.append('serial', payload.serial);
    data.append('plan_id', payload.plan_id);
    data.append('billing_cycle', payload.billing_cycle);
    if (payload.invoice_number) data.append('invoice_number', payload.invoice_number);
    if (payload.amount != null && payload.amount !== '') data.append('amount', payload.amount);
    if (payload.paid_at) data.append('paid_at', payload.paid_at);
    if (payload.notes) data.append('notes', payload.notes);
    return await loadJson(data, 't8_subscribers/create');
}

export async function t8_subscribers_update(token, payload) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', payload.id);
    if (payload.plan_id != null) data.append('plan_id', payload.plan_id);
    if (payload.billing_cycle != null) data.append('billing_cycle', payload.billing_cycle);
    if (payload.suspended != null) data.append('suspended', payload.suspended);
    return await loadJson(data, 't8_subscribers/update');
}

export async function t8_subscribers_add_payment(token, payload) {
    const data = new FormData();
    data.append('token', token);
    data.append('subscriber_id', payload.subscriber_id);
    data.append('invoice_number', payload.invoice_number);
    data.append('amount', payload.amount);
    if (payload.paid_at) data.append('paid_at', payload.paid_at);
    if (payload.notes) data.append('notes', payload.notes);
    data.append('qa', payload.qa ? '1' : '0');
    return await loadJson(data, 't8_subscribers/add_payment');
}

/** Vincula un correo TOMi.digital a un suscriptor T8. qa: true = QA, false = PROD. */
export async function t8_subscribers_link_tomi_email(token, payload) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', payload.id);
    data.append('email', payload.email);
    data.append('qa', payload.qa ? '1' : '0');
    return await loadJson(data, 't8_subscribers/link_tomi_email');
}

/** Desvincula el correo TOMi.digital de un suscriptor T8. qa: true = QA, false = PROD. */
export async function t8_subscribers_unlink_tomi_email(token, id, qa = false) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    data.append('qa', qa ? '1' : '0');
    return await loadJson(data, 't8_subscribers/unlink_tomi_email');
}

/**
 * Consulta estado de suscripción en msubscriptions por email (o id de suscriptor).
 * qa: true = QA, false = PROD.
 */
export async function t8_subscribers_tomi_subscription_status(token, payload) {
    const data = new FormData();
    data.append('token', token);
    if (payload.email) data.append('email', payload.email);
    if (payload.id != null) data.append('id', payload.id);
    data.append('qa', payload.qa ? '1' : '0');
    return await loadJson(data, 't8_subscribers/tomi_subscription_status');
}

/** Lista pinTypes grantables (Premium/PRO) según entorno QA/PROD. */
export async function t8_subscribers_list_pin_types(token, qa = false) {
    const data = new FormData();
    data.append('token', token);
    data.append('qa', qa ? '1' : '0');
    return await loadJson(data, 't8_subscribers/list_pin_types');
}

/** Activa (POST) o actualiza (fallback PATCH) suscripción interna TOMi.digital. */
export async function t8_subscribers_activate_tomi_subscription(token, payload) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', payload.id);
    data.append('pin_type_id', payload.pin_type_id);
    if (payload.reason) data.append('reason', payload.reason);
    data.append('qa', payload.qa ? '1' : '0');
    return await loadJson(data, 't8_subscribers/activate_tomi_subscription');
}

/** Sincroniza ends_at de TOMi.digital con next_due_date del suscriptor T8. */
export async function t8_subscribers_sync_tomi_subscription_ends(token, payload) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', payload.id);
    if (payload.reason) data.append('reason', payload.reason);
    data.append('qa', payload.qa ? '1' : '0');
    return await loadJson(data, 't8_subscribers/sync_tomi_subscription_ends');
}

/** Cambia pin_type_id de una suscripción interna activa (PATCH). */
export async function t8_subscribers_update_tomi_subscription_type(token, payload) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', payload.id);
    data.append('pin_type_id', payload.pin_type_id);
    if (payload.reason) data.append('reason', payload.reason);
    data.append('qa', payload.qa ? '1' : '0');
    return await loadJson(data, 't8_subscribers/update_tomi_subscription_type');
}

export async function add_license_stem(serialNum, contentId, endDate, args = '') {
    const data = new FormData();
    data.append('serial_num', serialNum);
    data.append('content_id', contentId);
    data.append('end_date', endDate);
    data.append('args', args ?? '');
    return await loadJson(data, 't8_services/add_license_stem');
}

export async function delete_license_stem(serialNum, contentId) {
    const data = new FormData();
    data.append('serial_num', serialNum);
    data.append('content_id', contentId);
    return await loadJson(data, 't8_services/delete_license_stem');
}

export async function update_license_stem(serialNum, contentId, endDate, args = '') {
    const data = new FormData();
    data.append('serial_num', serialNum);
    data.append('content_id', contentId);
    data.append('end_date', endDate);
    data.append('args', args ?? '');
    return await loadJson(data, 't8_services/update_license_stem');
}

export async function fix_tomi7_pending_areas(token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson(data, 't8_services/fix_tomi7_subjects');
}

export async function delete_transactions(token, selectedTransactionId){
    const data = new FormData();
    data.append('token', token);
    data.append('selectedTransactionId', selectedTransactionId);
    return await loadJson (data, 'financial/delete_transactions');
}

// SSL Certificate
export async function get_ssl_cert_info(token) {
    const data = new FormData();
    data.append('token', token);
    return await loadJson(data, 'ssl/get_ssl_info');
}

export async function upload_ssl_cert(token, file, expirationDate) {
    const data = new FormData();
    data.append('token', token);
    data.append('file', file);
    data.append('expiration_date', expirationDate);
    return await loadJson(data, 'ssl/upload_ssl_cert');
}

export async function set_strategy_to_transaction(token, trello_card_id, selectedTransactionId, selectedCategory){
    const data = new FormData();
    data.append('token', token);
    data.append('trello_card_id', trello_card_id);
    data.append('selectedTransactionId', selectedTransactionId);
    data.append('selectedCategory', selectedCategory);
    return await loadJson (data, 'financial/set_strategy_to_transaction');
}
///////////////////////////////////////////////////////

async function loadJsonWithUploadProgress(data, url, onProgress) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', baseURL + url + '.php');

        if (typeof onProgress === 'function') {
            xhr.upload.addEventListener('progress', (event) => {
                if (event.lengthComputable) {
                    onProgress({
                        loaded: event.loaded,
                        total: event.total,
                        percent: Math.min(100, Math.round((event.loaded / event.total) * 100)),
                    });
                }
            });
        }

        xhr.onload = () => {
            const resp = xhr.responseText;
            if (resp !== 'INVALID') {
                try {
                    if (resp === '[]') {
                        resolve(null);
                        return;
                    }
                    resolve(JSON.parse(resp));
                } catch (err) {
                    resolve(resp);
                }
            } else {
                resolve('INVALID');
            }
        };

        xhr.onerror = () => reject(new Error('Error de red al subir el archivo'));
        xhr.onabort = () => reject(new Error('Subida cancelada'));
        xhr.send(data);
    });
}

async function loadJson (data, url) {

    try {
        const response = await fetch(baseURL + url + ".php", {
            method: 'POST',
            
            body: data
        });
        const resp = await response.text();

        if(resp !== "INVALID"){
            try{
                if(resp === "[]")
                    return null;

                const jsonResult = JSON.parse(resp);
                return jsonResult;
            }catch(err){
                return resp;
            }
            
        }else{
            return "INVALID";
        }
       
    } catch (error) {
        console.error('Error:' + error);
        return null;
    }
}

async function loadJsonGET (url, queryParams = {}) {
    try {
        const urlObj = new URL(baseURL + url + '.php', window.location.origin);
        Object.keys(queryParams).forEach(key => {
            if (queryParams[key] !== undefined && queryParams[key] !== null) {
                urlObj.searchParams.append(key, queryParams[key]);
            }
        });

        const response = await fetch(urlObj.toString(), {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        });

        const resp = await response.text();

        if (!response.ok) {
            try {
                const errorData = JSON.parse(resp);
                console.error('API Error:', errorData);
                return "INVALID";
            } catch (err) {
                console.error('Error response (not JSON):', resp);
                return "INVALID";
            }
        }

        try {
            if (resp === "[]") {
                return null;
            }
            const jsonResult = JSON.parse(resp);
            return jsonResult;
        } catch (err) {
            console.error('JSON parse error:', err, 'Response:', resp);
            return resp;
        }
    } catch (error) {
        console.error('Error:', error);
        return null;
    }
}



